
export const getRefereeApiGet = (data) => {
    return data.data
}



